import { initializeBrowserPulse } from '@pulse/typescript';
import React, { useMemo } from 'react';
const PulseContext = React.createContext({});
const PulseProvider = (config) => {
    const initPulse = {
        app: config.app,
        sdks: config.sdks,
        config: {
            settings: config.settings,
            tracker: config.tracker
        }
    };
    const value = useMemo(() => {
        const { settings, tracker } = initializeBrowserPulse(initPulse);
        return {
            settings: settings && {
                getSettings: settings.get,
                getSegments: settings.getSegments,
                getExperiments: settings.getExperiments
            },
            tracker: tracker && {
                queueEmpty$: tracker.queueEmpty$
            }
        };
        // eslint-disable-next-line
    }, []);
    return React.createElement(PulseContext.Provider, { value: value }, config.children);
};
export { PulseContext, PulseProvider };
//# sourceMappingURL=pulse-react.context.js.map